import {
  normalizeServiceEoiDetails,
  SERVICE_EOI_DETAILS_SCHEMA_VERSION,
} from "./serviceEoiDetails";

export const SERVICE_EOI_MESSAGE_KIND = "remanufacturing_service_eoi";
export const SERVICE_EOI_MESSAGE_VERSION = 1;
export const SERVICE_EOI_MESSAGE_VERSION_V2 = SERVICE_EOI_DETAILS_SCHEMA_VERSION;

/**
 * Encodes expanded remanufacturing EOI into `message` for backends that only accept
 * productId, source, and message on POST /marketplace-orders.
 * @param {{ message?: string, eoiDetails?: Record<string, unknown>|null }} params
 */
export function encodeServiceEoiInterestMessage({ message, eoiDetails }) {
  const normalizedEoi = normalizeServiceEoiDetails(eoiDetails);
  const trimmedMessage = typeof message === "string" ? message.trim() : "";

  return JSON.stringify({
    kind: SERVICE_EOI_MESSAGE_KIND,
    version: SERVICE_EOI_MESSAGE_VERSION_V2,
    ...(normalizedEoi ? { eoiDetails: normalizedEoi } : {}),
    ...(trimmedMessage ? { text: trimmedMessage } : {}),
  });
}

/**
 * @param {unknown} message
 * @returns {{ text?: string, eoiDetails?: import("./serviceEoiDetails").ServiceEoiDetails }|null}
 */
export function parseServiceEoiInterestMessagePayload(message) {
  if (typeof message !== "string") return null;
  const trimmed = message.trim();
  if (!trimmed.startsWith("{")) return null;

  try {
    const parsed = JSON.parse(trimmed);
    if (
      !parsed ||
      typeof parsed !== "object" ||
      parsed.kind !== SERVICE_EOI_MESSAGE_KIND
    ) {
      return null;
    }

    const eoiDetails = normalizeServiceEoiDetails(parsed.eoiDetails);
    const text = typeof parsed.text === "string" ? parsed.text.trim() : "";

    if (!eoiDetails && !text) return null;

    return {
      ...(text ? { text } : {}),
      ...(eoiDetails ? { eoiDetails } : {}),
    };
  } catch {
    return null;
  }
}

/**
 * @param {unknown} message
 * @returns {import("./serviceOrderWorkflow").ServiceWorkflow|null}
 */
export function serviceWorkflowFromInterestMessage(message) {
  const payload = parseServiceEoiInterestMessagePayload(message);
  if (!payload?.eoiDetails) return null;

  return {
    phase: "eoi_received",
    eoiDetails: payload.eoiDetails,
  };
}

/**
 * Customer-facing message text (hides structured JSON envelope).
 * @param {unknown} message
 */
export function formatInterestMessageForDisplay(message) {
  const payload = parseServiceEoiInterestMessagePayload(message);
  if (payload?.text) return payload.text;
  if (payload?.eoiDetails) return "";
  return typeof message === "string" ? message : "";
}
